import type { CSSProperties, ReactNode } from "react";

/** SHELLS list copied from docs/handoff/006-shell-reference.html. Default is Pastel (index 0). */
export const SHELLS = [
  { n: "Pastel", c: "#f4a6cf", t: "#6fd7a8" },
  { n: "Jelly", c: "#5a63f0", t: "#ffb15a" },
  { n: "Teal", c: "#1c7c7d", t: "#d96b27" },
  { n: "Orange", c: "#e0732b", t: "#1c7c7d" },
  { n: "Plum", c: "#6d4fc2", t: "#f2b134" },
  { n: "Rose", c: "#d9437a", t: "#2aa6a0", lock: "ach" },
] as const;

/** PATS list copied from docs/handoff/006-shell-reference.html. Default is Plain (index 0). */
export const PATS = [
  { n: "Plain", v: "none" },
  { n: "Dots", v: "radial-gradient(rgba(255,255,255,.2) 2px,transparent 2.5px) 0 0/14px 14px" },
  {
    n: "Stripes",
    v: "repeating-linear-gradient(135deg,rgba(255,255,255,.14) 0 8px,transparent 8px 16px)",
    lock: "shop",
  },
] as const;

export interface ShellProps {
  looks: { shellColour: number; shellPattern: number };
  retro: boolean;
  children: ReactNode;
  hardwareButtons?: ReactNode;
  /** The shell slides away while the picture book is open. */
  away?: boolean;
  /** Removed from the layout (after it has slid away). */
  hidden?: boolean;
}

export function Shell({ looks, retro, children, hardwareButtons, away = false, hidden = false }: ShellProps) {
  const shell = SHELLS[looks?.shellColour ?? 0] ?? SHELLS[0];
  const pat = PATS[looks?.shellPattern ?? 0] ?? PATS[0];

  const style: CSSProperties = {
    "--shell": shell.c,
    "--trim": shell.t,
    "--pat": pat.v,
  } as CSSProperties;

  return (
    <div className="area">
      <div className={`rig${away ? " away" : ""}`} id="rig" hidden={hidden}>
        <div className="loop" aria-hidden="true" />
        <div
          className={`shell${retro ? " retro" : ""}`}
          id="shell"
          data-testid="shell"
          data-shell-colour={shell.n}
          data-shell-pattern={pat.n}
          style={style}
        >
          <div className="word" aria-hidden="true">
            ZOOKEEPBIT
          </div>
          <div className="bezel">{children}</div>
          <div className="trim" aria-hidden="true" />
          {hardwareButtons}
        </div>
      </div>
    </div>
  );
}
